import { AuthorizationConfig, GeneralEnvironmentInfo } from '../app/authorization_config';
import { AuthenticationSettings } from '../opc/shared/models/Authenticationsettings.model';

const Authentication: AuthenticationSettings = new AuthenticationSettings();

export const environment: AuthorizationConfig & GeneralEnvironmentInfo = {
  production: Authentication.production,
  issuer_uri: Authentication.issuer_uri,
  client_id: Authentication.client_id,
  redirect_uri: Authentication.redirect_uri,
  extras: {
    'prompt': 'login',
    'access_type': 'offline'
  }
}
// export const environment = {
//     production: false,
// };



// WEBPACK FOOTER //
// ./src/environments/environment.ts